import { TGetStateResponseDE } from '../lapiOverrideTypesDE';
import { TGetStateResponse } from '../types';

type TCustomerState = TGetStateResponse | TGetStateResponseDE;

function getApplicant(stateData?: TCustomerState) {
  if (!stateData) return;

  const people = stateData?.data?.application?.people;
  if (!people) return;

  const applicant = people.find((person) => {
    const roles = person?.roles || [];
    return roles.includes('applicant');
  })!;

  return applicant;
}

export function getApplicantEmail(stateData?: TCustomerState) {
  if (!stateData) return;

  const applicant = getApplicant(stateData);
  if (!applicant) return;

  const emails = applicant?.emails;
  if (!emails) return;

  const primaryEmail = emails.find((email) => email.type?.includes('primary'));

  return primaryEmail?.email;
}
